import React from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';

export default class Generic extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    modifyChild: PropTypes.bool,
    style: PropTypes.object,
    delay: PropTypes.number,
  };

  static defaultProps = {
    modifyChild: true,
    style: {},
    delay: 1
  };

  componentDidMount() {
    const { modifyChild, style, delay } = this.props;
    setTimeout(() => {
      const node = findDOMNode(this);
      if (node && modifyChild) {
        Object.assign(node.style, style);
      }
    }, delay);
  }

  render() {
    const { modifyChild, children, style } = this.props;

    if (modifyChild) {
      return children;
    }

    return (
      <div style={style}>
        {children}
      </div>
    );
  }

}
